import { Platform } from 'react-native';

export const TAB_BAR_HEIGHT = 55;

export function getTabBarTotalHeight(bottomInset: number): number {
  if (Platform.OS === 'web') {
    return 0;
  }

  if (Platform.OS === 'android') {
    return TAB_BAR_HEIGHT + (bottomInset > 0 ? bottomInset : 8);
  }

  return TAB_BAR_HEIGHT + bottomInset;
}

export function getContentBottomPadding(bottomInset: number): number {
  return getTabBarTotalHeight(bottomInset) + 8;
}
